import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export const Portfolio = () => {
  const clients = [
    { name: 'QDOBA', image: 'https://hungrmates.weebly.com/uploads/1/3/5/7/135795236/81e50fc78a01d9197dd9221a5ec12666-orig_2.jpg', category: 'Fast Casual' },
    { name: "Fazoli's", image: 'https://hungrmates.weebly.com/uploads/1/3/5/7/135795236/020bd59271a28b0c8ff8243a9d08068d-orig_2.jpg', category: 'Italian' },
    { name: 'Pot Belly', image: 'https://hungrmates.weebly.com/uploads/1/3/5/7/135795236/420e56f67776c91827e7ddd60e0e8c73-orig_2.jpg', category: 'Sandwiches' },
    { name: 'Pizza House', image: 'https://hungrmates.weebly.com/uploads/1/3/5/7/135795236/f1a9548a7d5f950ec84032205755ce4a-orig_2.jpg', category: 'Pizza' },
  ];

  return (
    <div>
      <section className="halftone-bg" style={{ background: '#FFD700', borderBottom: '4px solid #000', padding: '5rem 1.5rem', textAlign: 'center', position: 'relative' }}>
        <div className="container" style={{ maxWidth: '800px', position: 'relative', zIndex: 1 }}>
          <h1 className="heading-1" style={{ marginBottom: '1.5rem', color: '#000' }}>Our Portfolio</h1>
          <p style={{ fontSize: '1.25rem', color: '#333', fontWeight: 600 }}>See some of the restaurant apps we've built for our clients.</p>
        </div>
      </section>

      <section style={{ padding: '5rem 1.5rem', background: '#fff', borderBottom: '4px solid #000' }}>
        <div className="container">
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '2rem' }}>
            {clients.map((client, i) => (
              <div key={i} className="comic-card" style={{ padding: 0, overflow: 'hidden', cursor: 'pointer' }}>
                <div style={{ height: '320px', backgroundImage: `url(${client.image})`, backgroundSize: 'cover', backgroundPosition: 'center', borderBottom: '4px solid #000' }}></div>
                <div style={{ padding: '1.25rem' }}>
                  <div style={{ display: 'inline-block', padding: '4px 12px', background: '#FFD700', border: '2px solid #000', borderRadius: '4px', fontSize: '0.75rem', fontWeight: 800, textTransform: 'uppercase', marginBottom: '0.5rem', boxShadow: '2px 2px 0px 0px #000' }}>{client.category}</div>
                  <h3 style={{ fontFamily: "'Bangers', cursive", fontSize: '1.5rem', letterSpacing: '0.03em' }}>{client.name}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="halftone-bg" style={{ padding: '5rem 1.5rem', background: '#6A0DAD', textAlign: 'center', position: 'relative' }}>
        <div className="container" style={{ maxWidth: '600px', position: 'relative', zIndex: 1 }}>
          <h2 className="heading-2" style={{ marginBottom: '1.5rem', color: '#FFD700' }}>Want Your Restaurant Here?</h2>
          <p style={{ color: 'rgba(255,255,255,0.85)', marginBottom: '2rem', fontWeight: 500, fontSize: '1.125rem' }}>Book a demo and let's build your custom restaurant app.</p>
          <Link to="/book-demo" className="btn-primary" style={{ fontSize: '1.125rem', padding: '16px 32px' }}>
            Book a Free Demo <ArrowRight size={20} style={{ marginLeft: '0.5rem' }} />
          </Link>
        </div>
      </section>
    </div>
  );
};
